import {
	Box,
	createStyles,
	Group,
	Modal,
	Skeleton,
	Stack,
} from '@mantine/core';
import { Prism } from '@mantine/prism';
import { CopyButton, IconButton, Title } from '@repo/foundations';
import { QueryCode } from '../../../components/QueryCodeBlock/QueryCode';

const useStyles = createStyles((theme) => ({
	queryBox: {
		position: 'relative',
		padding: 0,
		borderRadius: theme.radius.md,
		border: `1px solid ${theme.other.getColor('border/primary/default')}`,
		overflow: 'hidden',
		width: '600px',
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: theme.spacing.sm,
		backgroundColor: theme.other.getColor('fill/primary/hover'),
		borderBottom: `1px solid ${theme.other.borderColor}`,
		overflow: 'hidden',
		minHeight: '28px',
	},
	title: {
		fontWeight: 600,
		color: theme.other.getColor('text/secondary/default'),
		margin: 0,
	},
	headerActions: {
		display: 'flex',
		gap: theme.spacing.xs,
	},
	sqlEditorWrapper: {
		position: 'relative',
		padding: '0',
		minHeight: '200px',
		overflow: 'hidden',
	},
	queryBlock: {
		overflowY: 'auto',
		'.mantine-Prism-code': {
			fontSize: 10,
		},
	},
}));

export interface IQuerySqlProps {
	sql: string | undefined | null;
	modalOpened: boolean;
	setModalOpened: (opened: boolean) => void;
}

export function QuerySql({ sql, modalOpened, setModalOpened }: IQuerySqlProps) {
	const { classes, theme } = useStyles();

	const shouldShowModal = modalOpened && !!sql;

	return (
		<Stack spacing="lg">
			{!!sql && (
				<Stack spacing={0} className={classes.queryBox}>
					<Box className={classes.header}>
						<Title order={4} className={classes.title}>
							{'SQL'}
						</Title>
						<Group className={classes.headerActions}>
							<IconButton
								iconName="arrowsDiagonal"
								variant="tertiary"
								onClick={() => setModalOpened(true)}
							/>
							<CopyButton value={sql || ''} type="copy" />
						</Group>
					</Box>
					<QueryCode query={sql || ''} className={classes.sqlEditorWrapper} />
				</Stack>
			)}
			{!sql && <Skeleton height={300} radius="lg" />}

			<Modal
				opened={shouldShowModal}
				size={theme.other.width.lg}
				title="Creation query"
				onClose={() => setModalOpened(false)}
			>
				<Prism language="sql" className={classes.queryBlock}>
					{sql ?? ''}
				</Prism>
			</Modal>
		</Stack>
	);
}
